import React, {Component} from 'react';
import styles from "../DatiSpecifici.module.css";
import Button from "../../../../../components/button/Button";
import Icon from "../../../../../components/icon/Icon";
import Utils from "../../../../../utils/Utils";
import OggettiUtili from "../../../../../utils/OggettiUtili";
import {withTranslation} from "react-i18next";
import SelectAutocomplete from "../../../../../components/selectAutocomplete/SelectAutocomplete";
import $ from "jquery";


class PatologieCroniche extends Component {

    state = {
        patologieCroniche: {
            fattore: [],
            corretto: []
        },
        clicksPatologie: 0,
        boxesPatologie: [],
        fattoriPredisponentiIncompleta: Utils.mapToArray(OggettiUtili.FattoriPredisponentiIncompleta).sort(Utils.SorterObjectDesc),
        fattoriPredisponenti: Utils.mapToArray(OggettiUtili.FattoriPredisponenti).sort(Utils.SorterObjectDesc)
    }

    constructor(props) {
        super(props);
        this.aggiungiPatologia = this.aggiungiPatologia.bind(this);
        this.setPatologia = this.setPatologia.bind(this);
        this.controlloData = this.controlloData.bind(this);
        this.aggiungiPatologiaAlloStato = this.aggiungiPatologiaAlloStato.bind(this)
        this.createJsonForBackend = this.createJsonForBackend.bind(this)
    }

    componentDidMount() {

        if (this.props.segnalazioneCopia.datiSpecifici) {
            if (this.props.segnalazioneCopia.datiSpecifici.patologieCroniche) {
                let propsPatologie = JSON.parse(JSON.stringify(this.props.segnalazioneCopia.datiSpecifici.patologieCroniche))
                let statePatologie = this.state.patologieCroniche
                statePatologie.fattore = propsPatologie.fattore ? propsPatologie.fattore : this.state.patologieCroniche.fattore
                if (statePatologie.fattore) {
                    for (let i = 0; i < statePatologie.fattore.length; i++) {
                        this.aggiungiPatologia();
                        this.state.clicksPatologie++
                    }
                    this.controlloData()
                } else {
                    this.aggiungiPatologia();
                    this.controlloData()
                }
            } else {
                this.aggiungiPatologiaAlloStato()
                this.aggiungiPatologia()
                this.controlloData()
            }
        } else {
            this.aggiungiPatologiaAlloStato()
            this.aggiungiPatologia()
            this.controlloData()
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.clicksPatologie > this.state.clicksPatologie) {
            this.aggiungiPatologia()
            this.props.setPatologieCroniche(this.state.patologieCroniche)
        }
        if (prevState !== this.state) {
            let patologieUnique = JSON.parse(JSON.stringify(this.state.patologieCroniche))
            patologieUnique.fattore = Utils.unique(this.state.patologieCroniche.fattore)
            let jsonBackend = this.createJsonForBackend(patologieUnique)
            this.props.setPatologieCroniche(this.state.patologieCroniche, jsonBackend)
        }
    }

    createJsonForBackend(patologieUnique) {

        let patologie = Object.assign({}, patologieUnique ? patologieUnique : this.state.patologieCroniche)
        if (patologie.fattore[0] === OggettiUtili.FattoriPredisponenti["23"].codice || patologie.fattore[0] === OggettiUtili.FattoriPredisponenti["24"].codice) {
            let fattoreNew = []
            fattoreNew[0] = this.state.patologieCroniche.fattore[0]
            patologie.fattore = fattoreNew
            // datiSpecifici.patologieCroniche = this.state.datiSpecifici.patologieCroniche.fattore[0]
            // this.setPatologieCroniche(datiSpecifici)
        }
        let patologieBackend = Utils.removeFieldFromObject(patologie, "corretto");

        let res = Utils.removeEmptyValueFromObject(patologieBackend);

        return res;

    }

    controlloData() {

        let patologia = this.state.patologieCroniche;
        patologia.corretto = []
        let controlloDati = {fattore: false}
        for (let i = 0; i < patologia.fattore.length; i++) {
            if (patologia.fattore[i] === null || patologia.fattore[i] === undefined || patologia.fattore[i] === "" || patologia.fattore[i] === "" && !controlloDati.fattore) {
                patologia.corretto[0] = "Campo \"Fattore o patologia riscontrata\" mancante"
                controlloDati.fattore = true
            }
        }
        return this.setState({patologieCroniche: patologia})

    }


    setPatologia(event) {
        let click = this.state.clicksPatologie - 1
        let patologieCroniche = this.state.patologieCroniche
        patologieCroniche.fattore.splice(event.target.id, 1, event.target.value)
        this.setState({patologieCroniche: patologieCroniche, clicksPatologie: click})
        $(function () {
            $('.selectpicker').selectpicker('refresh');
        });
        this.controlloData();
    }

    aggiungiPatologiaAlloStato() {
        let patologieCroniche = this.state.patologieCroniche
        if (this.props.malattiePremal.includes(this.props.segnalazioneCopia.malattia)) {
            patologieCroniche.fattore.push("491*")
        } else {
            patologieCroniche.fattore.push("")
        }
        this.setState({patologieCroniche: patologieCroniche})
        this.controlloData()
    }

    eliminaRow(i){
        let patologieCroniche = this.state.patologieCroniche;
        let boxesPatologie = this.state.boxesPatologie
        let clicksPatologie = this.state.clicksPatologie
        patologieCroniche.fattore.splice(i,1)
        boxesPatologie.splice(i,1)
        this.setState({boxesPatologie: boxesPatologie, patologieCroniche: patologieCroniche});
        if(i===1) clicksPatologie = clicksPatologie - 1
        else clicksPatologie = clicksPatologie - 2
        this.aggiungiPatologia(clicksPatologie)
        $(document).ready(function () {
            $('.selectpicker').selectpicker('refresh')
        });
    }

    aggiungiPatologia(clicksPatologie) {
        let clicks = clicksPatologie ? clicksPatologie : this.state.clicksPatologie === this.state.patologieCroniche.fattore.length ? this.state.clicksPatologie :this.state.clicksPatologie + 1
        let boxesPatologie = [];
        for (let i = 0; i < clicks; i++)
            boxesPatologie.push(
                <div>
                    <div className="row">
                        <div className="col-lg-6">
                            <p className={styles.testo}>{this.props.t("DatiSpecifici.PatologieCroniche.fattore")}<span
                                className={styles.mandatoryColor}>*</span></p>
                        </div>
                    </div>
                    <div className="row">
                        <div className={`col-lg-9 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <SelectAutocomplete
                                field={i}
                                id={i}
                                onChange={this.setPatologia}
                                value={this.state.patologieCroniche.fattore[i] === "491*"? "491" : this.state.patologieCroniche.fattore[i]}
                                disabled={this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                    this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)}
                                functionMap={(i >= 1 ? this.state.fattoriPredisponentiIncompleta : this.state.fattoriPredisponenti).map((oggetto) => {
                                    return (<option value={oggetto.codice} style={{backgroundColor:'white'}}>{oggetto.descrizione}</option>)
                                })}
                                addclass={!this.props.segnalazioneCopia.stepConfermati.datiSpecificiConfermati && this.props.malattiePremal.includes(this.props.segnalazioneCopia.malattia) && this.state.patologieCroniche.fattore[i] === "491*"? 'select-yellow' : !this.props.segnalazioneCopia.stepConfermati.datiSpecificiConfermati? 'select-white' : ''}
                            >
                            </SelectAutocomplete>
                        </div>
                        <div className={`${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            {i < 1 ? <fieldset
                                disabled={this.state.patologieCroniche.fattore[i] === OggettiUtili.FattoriPredisponenti["23"].codice || this.state.patologieCroniche.fattore[i] === OggettiUtili.FattoriPredisponenti["24"].codice || this.state.patologieCroniche.fattore[i] === "491*" || this.state.patologieCroniche.fattore[i] === ""}>
                                <Button
                                    onClick={() => {
                                        this.aggiungiPatologiaAlloStato();
                                        this.aggiungiPatologia()
                                    }}
                                    className={styles.testo}
                                    classes="btn mt-2 btnBluOutline mb-1 "
                                    style={{
                                        padding: "5px",
                                        border: "none",
                                        background: "none",
                                        float: "right",
                                        opacity: this.state.patologieCroniche.fattore[i] === OggettiUtili.FattoriPredisponenti["23"].codice || this.state.patologieCroniche.fattore[i] === OggettiUtili.FattoriPredisponenti["24"].codice || this.state.patologieCroniche.fattore[i] === "491*" || this.state.patologieCroniche.fattore[i] === "" ? "0.5" : "1"
                                    }}
                                    text={this.props.t("DatiSpecifici.PatologieCroniche.aggiungi")}
                                    icon={<Icon style={{paddingLeft: "4px", fill: "#0073e6"}} id="it-plus-circle"/>}
                                /></fieldset> :
                                !(this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                    this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)) ?
                                <span id={"elimina"+i}
                                                      onClick={()=>
                                                          this.eliminaRow(i)

                                                      }
                                ><Icon id={"it-delete"} style={{fill: "red", marginTop: "5px", cursor: "pointer"}} /></span> : <div></div>
                            }
                        </div>
                    </div>
                </div>
            )

        this.setState({boxesPatologie: boxesPatologie, clicksPatologie: clicks});
        this.controlloData()
    }


    render() {
        return (
            <div style={{marginTop: "1rem"}}>
                <h6>{this.props.t("DatiSpecifici.PatologieCroniche.titolo")}</h6>
                <hr className={styles.hr}/>
                <div className={"container"}>

                    {this.state.boxesPatologie}
                </div>
            </div>
        );
    }
}

export default withTranslation('common')(PatologieCroniche);
